import { Component, Input } from '@angular/core';
import { ComponentWithCopy } from '../../intefaces/interfaces';
import { Link } from '../../components/link/link';
import { HeadlineLarge } from '../../components/typography/headline-large/headline-large';
import { BodyLarge } from '../../components/typography/body-large/body-large';
import { AnimateOnScroll } from 'primeng/animateonscroll';

@Component({
  selector: 'app-feature-list-with-image',
  imports: [Link, HeadlineLarge, BodyLarge, AnimateOnScroll],
  templateUrl: './feature-list-with-image.html',
  styleUrl: './feature-list-with-image.css'
})
export class FeatureListWithImage {
  @Input() content!: ComponentWithCopy

}
